import { Context } from "@nuxt/types/app";

const DEFAULT_ERROR_MESSAGE = "Terjadi kesalahan. Silakan coba lagi.";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  /**
   * Formats error message for snackbar display
   * @param error - The error object from catch block
   * @returns Formatted HTML string for snackbar message
   */
  function formatErrorMessage(error: unknown): string {
    let message = DEFAULT_ERROR_MESSAGE;

    if (error && typeof error === "object" && "message" in error) {
      const translatedMessage = context.app.$helpers.translateKeyContent(
        "FalconErrorMessage",
        (error as Record<string,any>).error_code || (error as Record<string,any>).errorCode,
        DEFAULT_ERROR_MESSAGE
      )
      message = translatedMessage;
    }

    return `<b>Error!</b> ${message}`;
  }

  return {
    formatErrorMessage,
  };
}

